import {
  SignUpMessages,
  TranslationSignUpMessages
} from "../interfaces/signUpMessages";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationSignUpMessages = {
  [SignUpMessages.signUpTitlePage]: "Novo usuário",
  [SignUpMessages.signUpEmailLabel]: "E-mail",
  [SignUpMessages.signUpFullNameLabel]: "Nome completo",
  [SignUpMessages.signUpDocumentLabel]: "CPF",
  [SignUpMessages.signUpRoleLabel]: "Função",
  [SignUpMessages.signUpPhoneNumberLabel]: "Celular",
  [SignUpMessages.signUpClientName]: "Nome do Cliente",
  [SignUpMessages.signUpClientNameLabel]: "Nome do Cliente (Igual ao do contrato)",
  [SignUpMessages.signUpPasswordLabel]: "Senha",
  [SignUpMessages.signUpPasswordConfirmationLabel]: "Confirmação de senha",
  [SignUpMessages.signUpButton]: "Cadastrar",
  [SignUpMessages.signUpInvalidEmail]: "E-mail inválido",
  [SignUpMessages.signUpRequiredEmail]: "E-mail obrigatório",
  [SignUpMessages.signUpFullNameRequired]: "Nome completo obrigatório",
  [SignUpMessages.signUpPasswordRequired]: "Senha obrigatória",
  [SignUpMessages.signUpPasswordConfirmationRequired]:
    "Confirmação de senha obrigatória",
  [SignUpMessages.signUpPasswordConfirmationMatch]: "As senhas não conferem",
  [SignUpMessages.signUpFailed]:
    "Falha ao cadastrar, verifique seus dados e tente novamente"
};
